define([
    'underscore',
], function (
    _,
    ) {
    /**
     * conditional が定義済み(!undefined)なら block が実行され、
     * 未定義なら else が実行されます。
     *
     * @param conditional
     * @param options
     * @returns {*}
     */
    function defined(conditional, options) {
        if(_.isUndefined(conditional)) {
            return options.inverse(this);
        } else {
            return options.fn(this);
        }
    }

    return defined;
});



// WEBPACK FOOTER //
// ./common/ui/template/helper/defined.js